import { api } from "../lib/api";
import { fdate, run, useLoad } from "../lib/util";
import { Table, Empty, Select } from "../components/kit";

const ST = [["nova", "Nova"], ["em_contato", "Em contato"], ["convertida", "Convertida"], ["descartada", "Descartada"]];

export default function LeadsTab() {
  const [leads, reload] = useLoad(async () => (await api.get("/admin/leads")).data, []);
  const change = async (l, status) => {
    if (await run(() => api.put(`/admin/leads/${l.id}/status`, null, { params: { status } }), "Situação atualizada")) reload();
  };
  return (
    <div className="mt-4">
      <Table testid="leads-table">
        <thead><tr><th>Data</th><th>Nome</th><th>Escola</th><th>Contato</th><th>Município</th><th>Mensagem</th><th>Situação</th></tr></thead>
        <tbody>
          {(leads || []).map((l) => (
            <tr key={l.id}>
              <td>{fdate(l.created_at)}</td>
              <td className="font-semibold">{l.name}</td>
              <td>{l.school}</td>
              <td>{l.email}<div className="text-xs text-slate-500">{l.whatsapp}</div></td>
              <td>{l.municipio}</td>
              <td className="max-w-xs text-xs">{l.filling && <div className="font-semibold text-slate-700">{l.filling === "equipe" ? "Equipe MapIA faz o preenchimento" : "Gestor faz o preenchimento"}</div>}{l.message}</td>
              <td><Select className="py-1" value={l.status} onChange={(e) => change(l, e.target.value)} options={ST} /></td>
            </tr>
          ))}
        </tbody>
      </Table>
      {leads && !leads.length && <Empty>Nenhuma solicitação recebida pelo site.</Empty>}
    </div>
  );
}
